export default __webpack_public_path__ + "static/media/villa_2.0f1b421f.jpg";